/**
 * Calendar event sync status enum
 * Matches backend: backend-python/app/models/calendar.py sync_status field
 */
export enum CalendarEventSyncStatusEnum {
    CreatePending = 'CREATE_PENDING',
    UpdatePending = 'UPDATE_PENDING',
    DeletePending = 'DELETE_PENDING',
    Synced = 'SYNCED'
}

/**
 * Organization payment status enum
 * Matches backend: backend-python/app/models/organization.py PaymentStatus enum
 * Backend values: ACTIVE, CANCELLED, PAYMENT_FAILED
 */
export enum OrganizationPaymentStatusEnum {
    Active = 'ACTIVE',
    Cancelled = 'CANCELLED',
    PaymentFailed = 'PAYMENT_FAILED'
}

/**
 * Plan monetary type enum
 * Matches backend: backend-python/app/models/organization.py MonetaryType enum
 */
export enum PlanMonetaryTypeEnum {
    FREE = 'FREE',
    PAID = 'PAID',
    FREE_TRIAL = 'FREE_TRIAL'
}

/**
 * Invoice document type enum
 * Matches backend: backend-python/app/models/patient.py document_type field
 */
export enum InvoiceDocumentTypeEnum {
    INVOICE = 'INVOICE',
    PROFORMA_INVOICE = 'PROFORMA_INVOICE'
}

/**
 * Invoice status enum
 * Matches backend: backend-python/app/models/patient.py status field
 */
export enum InvoiceStatusEnum {
    Paid = 'PAID',
    Unpaid = 'UNPAID',
    Cancelled = 'CANCELLED',
    UnpaidProforma = 'UNPAID_PROFORMA',
    CancelledProforma = 'CANCELLED_PROFORMA'
}

/**
 * Subscription status enum
 * Matches backend: backend-python/app/models/organization.py SubscriptionStatus enum
 */
export enum SubscriptionStatusEnum {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Trial = 'TRIAL',
    Expired = 'EXPIRED',
    Cancelled = 'CANCELLED'
}

/**
 * Medical staff role enum
 * Matches backend: backend-python/app/models/medical_staff.py Role enum
 */
export enum Role {
    ClinicAdmin = 'CLINIC_ADMIN',
    Doctor = 'DOCTOR',
    Dentist = 'DENTIST',
    Assistant = 'ASSISTANT',
    Receptionist = 'RECEPTIONIST',
    Hygienist = 'HYGIENIST',
    Orthodontist = 'ORTHODONTIST'
}

/**
 * Condition type enum
 * Removed - use ConditionTypeEnum from api-client/api.ts instead
 * Backend values: DIAGNOSE, ILLNESS, MEDICATION, ALLERGY
 */

/**
 * Invoice payment method enum
 * Matches backend: backend-python/app/models/patient.py payment_method field
 */
export enum InvoicePaymentMethodEnum {
    CASH = 'CASH',
    CARD = 'CARD',
    BANK_TRANSFER = 'BANK_TRANSFER'
}
